import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { getPlanTypeList } from '../../../actions/farm';
import { applyFilters } from "../../../actions/crew-kanban";
import { Modal } from "../../widgets";

const PlanTypeSelection = props => {
    const [openModal, setModal] = useState(false);
    const [planType, setPlanType] = useState(null);
    const { selected, haveChanges, actions, planTypeList } = props;
    const options = planTypeList.map(e => ({ id: e.plan_type_id, label: e.plan_type }));

    useEffect(() => {
        actions.getPlanTypeList();
    }, []);

    const onSelect = item => {
        setPlanType(item);
        if (!haveChanges) actions.applyFilters({ planTypeId: parseInt(item.id), isSelectedPlanUpdated: false });
        else setModal(true);
        return;
    };

    const getLabel = id => {
        const findOptions = options.filter(e => e.id === id);
        return (findOptions.length > 0) ? findOptions[0].label : "";
    };

    return <>
        <DropdownButton className={`dropdown-plantype ${props.className || ""}`}
            variant="outline-success" size="sm" title={getLabel(selected)}>
            {options.map(e =>
                <Dropdown.Item key={e.id} eventKey={e.id}
                    active={e.id === selected} onSelect={onSelect.bind(this, e)}>
                    <i className="fa fa-circle" aria-hidden="true"></i> {e.label}
                </Dropdown.Item>)}
        </DropdownButton>
        <Modal.Confirm
            className="modal-confirm-lost"
            isOpen={openModal}
            onConfirm={() => actions.applyFilters({ planTypeId: planType.id })}
            iconClassName="fa fa-exclamation icon-warning"
            body={`Your changes will be lost.`}
            onHide={() => { setModal(!openModal) }} />
    </>
};

const mapStateToProps = state => ({
    planTypeList: state.farm.planTypeList,
    haveChanges: Object.keys(state.crewKanban.crews).length > 0 ?
        Object.keys(state.crewKanban.crews)
            .map(id => state.crewKanban.crews[id])
            .filter(e => e && e.isChanged).length > 0 : false,
    selected: state.crewKanban.filters.planTypeId
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ getPlanTypeList, applyFilters }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(PlanTypeSelection);
